import React, { useEffect, useState } from 'react';
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetFooter,
} from 'src/@/components/ui/sheet';
import { Input } from 'src/@/components/ui/input';
import { Label } from 'src/@/components/ui/label';
import { LoadingButton } from 'src/@/components/ui/loading-button';
import v2_actionCriarPipeline from 'src/actions/v2/cliente/v2_actionCriarPipeline';
import v2_actionEditarPipeline from 'src/actions/v2/crm/v2_actionEditarPipeline';

export default function DrawerNovoFunil({
    user,
    cliente,
    open,
    isEdit,
    pipelineId,
    onClose,
    onCallback,
    pipeline
}) {
    const [loading, setLoading] = useState(false);
    const [nome, setNome] = useState('');
    const [descricao, setDescricao] = useState('');

    async function handleCriarFunil() {
        try {
            setLoading(true);
            let data = {
                scope: {
                    nome: nome,
                    descricao: descricao,
                    criadoPor: user._id
                }
            }
            let result = await v2_actionCriarPipeline(cliente._id, data);
            if (result.data.data) {
                onCallback();
                onClose();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    async function handleEditarPipilene(id, scope) {
        try {
            setLoading(true);
            let data = {
                action: "editar_pipeline",
                scope: scope
            }
            await v2_actionEditarPipeline(id, data, cliente._id);
            onCallback();
            onClose();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    function handleOnClose() {
        onClose();
        setNome('');
        setDescricao('');
    }

    useEffect(() => {
        if (isEdit && pipeline) {
            setNome(pipeline.pipeline_nome || '');
            setDescricao(pipeline.description || '');
        } else if (!open) {
            setNome('');
            setDescricao('');
        }
    }, [pipeline, isEdit, open])

    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && handleOnClose()}>
            <SheetContent className="w-full sm:max-w-md bg-white p-6">
                <SheetHeader className="mb-6 text-left">
                    <SheetTitle className="text-xl font-bold text-gray-900">
                        {isEdit ? "Editar" : "Criar"} Funil
                    </SheetTitle>
                </SheetHeader>

                <div className="flex flex-col gap-6">
                    <div className="grid gap-2">
                        <Label htmlFor="nome" className="text-sm font-semibold text-gray-700">
                            Nome
                        </Label>
                        <Input
                            id="nome"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            placeholder="Ex: Comercial"
                            className="h-10 rounded-md border-gray-200 bg-gray-50 focus:border-[#7C3AED] focus:ring-0"
                        />
                    </div>
                    <div className="grid gap-2">
                        <Label htmlFor="descricao" className="text-sm font-semibold text-gray-700">
                            Descrição
                        </Label>
                        <Input
                            id="descricao"
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            placeholder="Ex: Funil de vendas principal"
                            className="h-10 rounded-md border-gray-200 bg-gray-50 focus:border-[#7C3AED] focus:ring-0"
                        />
                    </div>
                </div>

                <SheetFooter className="mt-8 flex-col sm:flex-col gap-3">
                    <LoadingButton
                        loading={loading}
                        onClick={() => {
                            if (isEdit) {
                                handleEditarPipilene(pipelineId, { nome: nome, description: descricao })
                            } else {
                                handleCriarFunil()
                            }
                        }}
                        className="w-full bg-[#7C3AED] hover:bg-[#6d28d9] text-white h-11"
                    >
                        {isEdit ? "Salvar Alterações" : "Criar Funil"}
                    </LoadingButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
